import http from "infra/http";
import { useMutation } from "react-query";

function useRejeitarProcuracao({
  idVotacao,
  idProcuracao,
}: {
  idVotacao: string;
  idProcuracao: string;
}) {
  return useMutation(
    `rejeitar/v1/votacao/${idVotacao}/procuracao/${idProcuracao}`,
    async (observacao: string) => {
      const result = await http.post(
        `/v1/votacao/${idVotacao}/procuracao/${idProcuracao}/rejeitar`,
        { observacao }
      );

      return result;
    },
    { retry: false }
  );
}

export default useRejeitarProcuracao;
